import React, { FC, PropsWithChildren } from "react";

import { useTabContext } from "@mui/lab/TabContext";
import { TabPanelProps as MuiTabPanelProps } from "@mui/lab/TabPanel";

const TabPanel: FC<PropsWithChildren<MuiTabPanelProps>> = ({
  children,
  ref,
  ...props
}) => {
  const context = useTabContext();

  if (!context) {
    throw new Error("TabPanel must be a child of TabContext");
  }

  const visible = props.value === context.value;

  if (visible) {
    return <div {...props}>{children}</div>;
  }

  return null;
};

export default TabPanel;
